<mat-accordion *ngIf="nations.length > 0">
  <mat-expansion-panel
    class="expansion-panel-gray"
    *ngFor="let nation of nations; index as nationId"
    [(expanded)]="expanded[nationId]"
  >
    <mat-expansion-panel-header>
      <mat-panel-title fxLayoutAlign="start center">
        <span class="header-title" fxFlex>
          {{ nation.name }}
          <span *ngIf="nation.name">
            &mdash;
            <span *ngIf="nation.all">tutte le regioni</span>
            <span *ngIf="!nation.all">{{ nation.regions.length }} regioni</span>
          </span></span
        >
        <div class="header-actions">
          <button
            type="button"
            mat-icon-button
            matTooltip="Rimuovi"
            (click)="removeNation(nation)"
          >
            <mat-icon aria-label="Rimuovi">delete</mat-icon>
          </button>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div fxLayout="row" fxLayoutAlign="start center">
      <mat-form-field appearance="outline">
        <mat-label>Nazione</mat-label>
        <input
          required
          name="nation_{{ nationId }}"
          matInput
          [(ngModel)]="nation.name"
          type="text"
          required
        />
      </mat-form-field>
      &nbsp;&nbsp;&nbsp;
      <span>Sei esperto di tutte le regioni in {{ nation.name }}?</span>
      &nbsp;&nbsp;&nbsp;
      <mat-slide-toggle
        [(ngModel)]="nation.all"
        name="nation_{{ nationId }}_all"
      >
        {{ nation.all ? "Sì, tutte" : "No, solo alcune" }}</mat-slide-toggle
      >
    </div>

    <div *ngIf="!nation.all">
      <app-user-detail-destinations-regions
        [regions]="nation.regions"
        [nation]="nation"
      ></app-user-detail-destinations-regions>
    </div>
  </mat-expansion-panel>
</mat-accordion>

<div class="add-button-container">
  <a mat-raised-button (click)="addNation()">
    <mat-icon>add</mat-icon> Aggiungi una nazione
  </a>
</div>
